<template>
  <div class="bg">
    <v-container class="responsive-container shadow">
      <v-col class="justify-center">
        <h1
          style="
            font-size: 28px;
            font-style: normal;
            font-weight: 700;
            line-height: 39px;
            letter-spacing: 0em;
            text-align: center;
          "
        >
          {{veriftype}} Verification
        </h1>

        <p
          style="
            font-size: 20px;
            font-style: normal;
            font-weight: 400;
            line-height: 27px;
            letter-spacing: 0em;
            text-align: center;
            color: #A5B3BF;
            margin-top: 20px;
            margin-bottom: 30px;
          "
        >
          Enter the verification code {{ wordingVerif }}
        </p>

        <div class="otp-input-cloudeka-container d-flex justify-center">
          <bach-otp-input
            ref="otpInput"
            input-classes="otp-input-cloudeka"
            separator=""
            :num-inputs="numInputs"
            :should-auto-focus="true"
            :is-input-num="true"
            @on-change="otpOnChange"
            @on-complete="otpOnComplete"
          />
        </div>

        <p class="error--text ma-2" :style="{ opacity: otpError ? 1 : 0 }">
          {{ otpError }}
        </p>
        <div v-if="isMfaActive == 'false'">
          <p v-if="interval2 && interval2 > 0" :style="{ marginTop: '20px' }" class="text-center">
            Code will expire in {{ $moment(interval2).format('mm:ss') }}
          </p>
          <p v-else class="error--text text-center">
            Code is expired, please resend the code.
          </p>
        </div>
        <v-btn
          id="submit"
          block
          height="50"
          depressed
          color="secondary"
          class="mr-4 text-capitalize font-weight-bold"
          style="margin-top: 20px; margin-bottom: 20px"
          @click="verify"
          :disabled="loading || interval2 < 0"
        >
          <!-- loading indicator -->
          <beat-loader v-if="loading" :loading="loading" :color="'white'" :size="'10px'" class="ml-2" />

          {{ loading ? "Verify..." : "Verify" }}
        </v-btn>

        <!-- <div class="d-flex justify-end">
          <button
            class="error--text"
            @click="logout"
          >
            Logout
          </button>
        </div> -->

        <p v-if="isMfaActive == 'false'" class="text-center">
          Don’t receive the Code?

          <span v-if="loading">loading...</span>

          <template v-else>
            <span v-if="interval && interval > 0">
              {{ $moment(interval).format('mm:ss') }}
            </span>

            <button
              v-else
              @click="resendOTP"
              style="
                color: #2C94D2;
                cursor: pointer;
              "
            >
              <u>Resend</u>
            </button>
          </template>
        </p>
        <p v-if="isMfaActive == 'true' && mfaTimerDone && role !== 'GodMode'">
          Having trouble with your multi-factor authentication device?
          <span style="
            color: #2C94D2;
            cursor: pointer;
          " @click="generateAuth()"
          >Use email authentication instead.</span>
        </p>
      </v-col>
    </v-container>
    <generateEmailAuth 
      v-if="generateAuthOpen" v-model="generateAuthOpen"
    />
  </div>
</template>

<script>
import api from '@/lib/api'
import localstorage from '@/lib/localstorage'
import externalSubDomain from '@/lib/externalSubDomain'
import generateEmailAuth from "./generateEmailAuth.vue"
import Vue from "vue"

export default {
  components: { generateEmailAuth },
  data() {
    return {
      loading: false,
      otp: null,
      otpError: '',
      interval: 90000,
      interval2: 300000,
      intervalFunc: null,
      mfaTimerDone: false,
      veriftype: '',
      numInputs: null,
      wordingVerif: '',
      isMfaActive: null,
      generateAuthOpen: false,
      role: null
    }
  },
  methods: {
    async verify() {
      const uid = localstorage.getItem("uid")
      this.otpError = ''
      let payload = {
        user_id: uid,
        cid: localStorage.getItem("cid"),
        cid_mfa: localStorage.getItem("cid_mfa"),
        otp: this.otp
      }

      if (!this.otp) {
        this.otpError = 'Value is required'
        return
      }

      this.loading = true
      try {
        const res = await api.POST('/user/validate-device', payload)
        const token = res.data.token
        localstorage.setItem("token", token)
        localstorage.removeItem('need_validate')
        localstorage.removeItem('timestamp')
        if (res.data.enforce_password) {
          localstorage.setItem("force_change_password", true)
          location.href = "/force-change-password";
          return
        }
        location.href = "/";
      } catch (err) {
        let errmsg = "Sorry, an error occurred while submitting OTP"
        if (err?.response?.data?.data) {
          errmsg = err.response.data.data
        }
        this.$store.dispatch("HOMEPAGE/showErrorToast", errmsg)
        if (errmsg === 'Too many OTP Code attempt' || errmsg === 'Active OTP request not found') {
          this.logout()
        }
      }
      this.loading = false
    },
    otpOnChange(val) {
      this.otp = val
    },
    otpOnComplete(val) {
      this.otp = val
    },
    intervalOn() {
      this.interval -= 1000
      this.interval2 -= 1000
    },
    async resendOTP() {
      localstorage.setItem('timestamp', new Date())
      const uid = localstorage.getItem("uid")
      this.loading = true
      try {
        const external_subdomain = externalSubDomain.getSubDomain()
        await api.POST(`/user/resend-validate/${uid}`, { external_subdomain })
        this.interval = 90000
        this.interval2 = 300000
        clearInterval(this.intervalFunc)
        this.intervalFunc = setInterval(this.intervalOn, 1000)
      } catch (err) {
        let errmsg = "Sorry, an error occurred while sending the OTP"
        if (err?.response?.data?.data) {
          errmsg = err.response.data.data
        }
        this.$store.dispatch("HOMEPAGE/showErrorToast", errmsg)
        if (errmsg === 'Too many OTP Code attempt' || errmsg === 'Active OTP request not found') {
          this.logout()
        }
      }
      this.loading = false
    },
    logout() {
      const context = this.$store
      context.commit("ROLEPERMISSION/setuser", {}, { root: true })
      Vue.prototype.$disconnect()
      const cid = localstorage.getItem('cid')
      localstorage.clear()
      if (cid) {
        localstorage.setItem('cid', cid)
      }
      context.commit("setToastWS", false)
      if (this.$router.history.current.path != "/") {
        this.$router.replace("/")
      }
    },
    generateAuth() {
      this.generateAuthOpen = true
    }
  },
  mounted() {
    this.isMfaActive = localStorage.getItem('is_mfa_active')
    this.role = localstorage.getItem('role')
    localstorage.removeItem('token')

    if (this.isMfaActive == 'true') {
      this.veriftype = "TOTP"
      this.numInputs = 6
      this.wordingVerif = "from your Authenticator Apps"
      setTimeout(() => {
        this.mfaTimerDone = true
      }, 10000)
    } else {
      this.veriftype = "OTP"
      this.numInputs = 4
      this.wordingVerif = "we just sent you on your email"
    }

    const timestamp = localstorage.getItem('timestamp')
    if (timestamp) {
      const then = Date.parse(timestamp)
      const now = Date.now()
      const difference = now - then
      if (difference < 90000) {
        this.interval -= difference
        this.interval2 -= difference
      }
    }
    this.intervalFunc = setInterval(this.intervalOn, 1000)
  },
  beforeDestroy() {
    clearInterval(this.intervalFunc)
  }
}
</script>


<style scoped>
.bg {
  background-image: url('~@/assets/g8429.png');
  background-position: right bottom;
  padding-bottom: 50px;
  background-size: contain;
}

.shadow {
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  background-color: white;
}

.responsive-container {
  margin-top: 100px;
  width: 612px;
  padding-left: 91px;
  padding-right: 91px;
}

@media only screen and (max-width: 612px) {
  .responsive-container {
    width: 100%;
    padding-left: 0;
    padding-right: 0;
  }
}

.otp-input-cloudeka-container div {
  display: flex;
  justify-content: space-between;
}
</style>
